import { createContext, useContext, useState, useEffect } from 'react'
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, loginRequest } from '../msalConfig';
import { AuthenticationService } from '../services/AuthenticationService';
import { useUtiles } from './utilesContext';
import { useNavigate } from 'react-router';
import Swal from 'sweetalert2';



const AuthContext = createContext()

export const useAuth = () => {
    return useContext(AuthContext)
}
const msalInstance = new PublicClientApplication(msalConfig);


export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [authUser, setAuthUser] = useState(null);
    const [accessToken, setAccessToken] = useState(null);
    const [refreshToken, setRefreshToken] = useState(null);

    const [isInitialized, setIsInitialized] = useState(false);

    const [messageError, setMessageError] = useState(null);

    const [loadingRedirectCallback, setLoadingRedirectCallback] = useState(false);

    const { setAlertSnackbar, resetOpenSilder } = useUtiles()
    const navigate = useNavigate();

    // Initialize MSAL
    useEffect(() => {
        const initializeMsal = async () => {
            try {
                await msalInstance.initialize().then(() => {
                    console.log("MSAL ha sido inicializado correctamente");
                }).catch(error => {
                    console.error("Error al inicializar MSAL:", error);
                });

                setIsInitialized(true);
            } catch (error) {
                console.error('Error initializing MSAL:', error);
            }
        };

        initializeMsal();
        getLocalStorage();
    }, [msalInstance]);

    //Obtener los tokens y el usuario del localStorage
    useEffect(() => {
        const accessToken = localStorage.getItem("accessToken");
        const refreshToken = localStorage.getItem("refreshToken");
        const authUser = localStorage.getItem("authUser");
        if (accessToken && refreshToken && authUser) {
            setAccessToken(accessToken);
            setRefreshToken(refreshToken);
            setAuthUser(JSON.parse(authUser));
        }
    }, []);


    //Metodo para obtener los tokens y el usuario del localStorage
    const [loading, setLoading] = useState(true);
    const getLocalStorage = () => {
        const accessToken = localStorage.getItem("accessToken");
        const refreshToken = localStorage.getItem("refreshToken");
        const authUser = localStorage.getItem("authUser");
        if (accessToken && refreshToken && authUser) {
            setAccessToken(accessToken);
            setRefreshToken(refreshToken);
            setAuthUser(JSON.parse(authUser));
        }
        setLoading(false);
    }

    //Metodo para resetear los tokens y el usuario del localStorage
    const resetLocalStorage = () => {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("authUser");
        setAuthUser(null);
        setAccessToken(null);
        setRefreshToken(null);
    }


    /**
     * 
     * METODOS PARA INCIIAR SESIÓN
     */



    /**
     * Iniciar sesión con Microsoft
     */

    const loginWithMicrosoft = async () => {

        try {
            await msalInstance.clearCache();
            await msalInstance.loginRedirect(loginRequest);

        } catch (error) {
            console.log(error);
        }

    }


    /**
     * Iniciar sesión con correo electrónico
     */
    const [loadingLoginEmail, setLoadingLoginEmail] = useState(false);
    const loginWithEmail = async (email, password) => {
        try {
            setLoadingLoginEmail(true);
            const response = await AuthenticationService.loginEmail({ email, password });
            console.log("RESPONSE", response);
            if (response.status === 200) {
                setAuthUser(response.data.user);
                setAccessToken(response.data.access);
                setRefreshToken(response.data.refresh);

                //guardar el accessToken, refreshToken y authUser en el localStorage
                localStorage.setItem("accessToken", response.data.access);
                localStorage.setItem("refreshToken", response.data.refresh);
                localStorage.setItem("authUser", JSON.stringify(response.data.user));

                setMessageError(null);
                setLoadingLoginEmail(false);
                return true;
            }
            return false;
        } catch (error) {
            console.log(error);
            setMessageError(error.response.data.message);
            setLoadingLoginEmail(false);
            return false;
        }
    }



    //Metodo para cerrar sesión
    const [loadingLogout, setLoadingLogout] = useState(false);
    const logout = async () => {
        try {
            setLoadingLogout(true);

            // Verificar si hay datos de MSAL
            const isMicrosoftSession = localStorage.getItem('msal.account.keys') !== null;
            const refresh = localStorage.getItem("refreshToken");

            // Primero limpiar la caché de MSAL si es una sesión de Microsoft
            if (isMicrosoftSession) {
                await msalInstance.clearCache();
                //await msalInstance.logout();
            }

            // Luego hacer el logout en el backend
            if (refresh) {
                const response = await AuthenticationService.logout({ refresh });
                if (response.status === 200) {
                    // Limpiar el localStorage
                    resetLocalStorage();
                    // Limpiar cualquier estado de autenticación
                    setIsAuthenticated(false);
                    setAuthUser(null);
                    setAccessToken(null);
                    setRefreshToken(null);

                    // Redirigir al login después de que todo se haya limpiado
                    window.location.replace("/login");
                }
            } else {
                // Si no hay refresh token, solo limpiar el estado local
                resetLocalStorage();
                setIsAuthenticated(false);
                setAuthUser(null);
                setAccessToken(null);
                setRefreshToken(null);
                window.location.replace("/login");
            }
        } catch (error) {
            console.error("Error durante el logout:", error);
            // Asegurarse de limpiar todo incluso si hay error
            resetLocalStorage();
            setIsAuthenticated(false);
            setAuthUser(null);
            setAccessToken(null);
            setRefreshToken(null);
            window.location.replace("/login");
        } finally {
            setLoadingLogout(false);
        }
    }








    /**
     * CALLBACK PARA REDIRECT CON MICROSOFT
     */
    const handleRedirectCallback = async () => {
        try {
            setLoadingRedirectCallback(true);
            const response = await msalInstance.handleRedirectPromise();


            // Obtener todas las cuentas
            const accounts = msalInstance.getAllAccounts();

            if (!response) {
                setLoadingRedirectCallback(false);
                return null;
            }

            try {

                const msToken = response.accessToken;
                const dataLogin = {
                    email: response.account.username,
                    avatar: response.account.avatar,
                    ms_token: msToken,
                }

                //realizar la validacion en el backend
                const responseBackend = await AuthenticationService.loginWithMicrosoft(dataLogin);
                if (responseBackend.status === 200) {
                    console.log("RESPONSE BACKEND", responseBackend);
                    setAuthUser(responseBackend.data.user);
                    setAccessToken(responseBackend.data.access);
                    setRefreshToken(responseBackend.data.refresh);

                    //guardar el accessToken, refreshToken y authUser en el localStorage
                    localStorage.setItem("accessToken", responseBackend.data.access);
                    localStorage.setItem("refreshToken", responseBackend.data.refresh);
                    localStorage.setItem("authUser", JSON.stringify(responseBackend.data.user));

                    setLoadingRedirectCallback(false);
                    setMessageError(null);
                    return true;
                }
                return false;

            } catch (error) {
                console.log(error);
                setLoadingRedirectCallback(false);
                setMessageError(error.response.data.message);
                return false;
            }

        } catch (error) {
            console.log(error);
            setLoadingRedirectCallback(false);
            setMessageError(error.response.data.message);
            return false;
        }
    }



    /**
     * ROLES Y PERMISOS
     */

    const [roles, setRoles] = useState([]);
    const [roleUser, setRoleUser] = useState({
        name: '',
        description: '',
        permissions: [],
        view_only_ot_assigned: false,
        allow_campus_all: false,
        user_task_manager: false,
        user_task_attender: false,
        can_finish_ot: false,
        can_return_ot_pending: false,
        can_reassing_ot: false
    });


    const [permission, setPermission] = useState({
        name: '',
        section_hash_code: '',
        actions: []
    });

    const [loadingGetRole, setLoadingGetRole] = useState(false);

    //Obtener todos los roles
    const [loadingGetRoles, setLoadingGetRoles] = useState(false);
    const getAllRoles = async (data) => {
        try {
            setLoadingGetRoles(true);
            const response = await AuthenticationService.getRoles(data);
            setRoles(response.data);
            console.log("ROLES", response.data);

        } catch (error) {
            console.log(error);
        } finally {
            setLoadingGetRoles(false);
        }
    }

    //Obtener el rol por el hash code
    const getRoleByHashCode = async (hash_code) => {
        try {
            setLoadingGetRole(true);
            const response = await AuthenticationService.getByHashCode(hash_code);
            setRoleUser(response.data);
            return response.data;
        } catch (error) {
            console.log(error);
            setAlertSnackbar({
                open: true,
                message: "Ocurrió un error al obtener el rol",
                severity: 'error'
            })
            return null; s
        } finally {
            setLoadingGetRole(false);
        }

    }


    //Crear un rol
    const [loadingCreateRole, setLoadingCreateRole] = useState(false);
    const createRole = async (data) => {
        try {
            setLoadingCreateRole(true);
            const response = await AuthenticationService.createRole(data);
            if (response.status === 200) {
                setRoleUser(response.data);
                navigate('/rrhh/roles/crear/' + response.data.hash_code);
            }
            setAlertSnackbar({
                open: true,
                message: "Rol creado correctamente",
                severity: 'success'
            })
        } catch (error) {
            console.log(error);
            setAlertSnackbar({
                open: true,
                message: error.response.data || "Ocurrió un error al crear el rol",
                severity: 'error'
            })
        } finally {
            setLoadingCreateRole(false);
        }
    }

    //Actualizar un rol
    const [loadingUpdateRole, setLoadingUpdateRole] = useState(false);
    const updateRoleExist = async (data) => {
        try {
            setLoadingUpdateRole(true);
            const dataUpdate = {
                hash_code: roleUser.hash_code,
                name: data.name,
                description: data.description,
                view_only_ot_assigned: data.view_only_ot_assigned,
                allow_campus_all: data.allow_campus_all,
                user_task_manager: data.user_task_manager,
                user_task_attender: data.user_task_attender,
                can_finish_ot: data.can_finish_ot,
                can_return_ot_pending: data.can_return_ot_pending,
                can_reassing_ot: data.can_reassing_ot
            }
            const response = await AuthenticationService.updateRole(dataUpdate);
            if (response.status === 200) {
                setRoleUser(response.data);
                navigate('/rrhh/roles/crear/' + response.data.hash_code);
            }
            setAlertSnackbar({
                open: true,
                message: "Rol actualizado correctamente",
                severity: 'success'
            })
        } catch (error) {
            console.log(error);
            setAlertSnackbar({
                open: true,
                message: error.response.data || "Ocurrió un error al actualizar el rol",
                severity: 'error'
            })
        } finally {
            setLoadingUpdateRole(false);
        }
    }

    //Eliminar un rol

    const [loadingDeleteRole, setLoadingDeleteRole] = useState(false);
    const deleteRole = async (hash_code) => {
        const confirmate = await Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            customClass: {
                container: 'custom-swal2-container',
                popup: 'custom-swal2-popup',
                backdrop: 'custom-swal2-backdrop',
            }
        })
        if (!confirmate.isConfirmed) return;
        try {
            setLoadingDeleteRole(true);
            const response = await AuthenticationService.deleteRole(hash_code);
            if (response.status === 200) {
                navigate('/rrhh/roles');
            }
            setAlertSnackbar({
                open: true,
                message: "Rol eliminado correctamente",
                severity: 'success'
            })
        } catch (error) {
            console.log(error);
            setAlertSnackbar({
                open: true,
                message: error.response.data || "Ocurrió un error al eliminar el rol",
                severity: 'error'
            })
        } finally {
            setLoadingDeleteRole(false);
        }
    }


    const [permissions, setPermissions] = useState([]);

    /**
     * PERMISOS
     */
    const [loadingGetPermissions, setLoadingGetPermissions] = useState(false);
    const getPermissionsByRole = async (role_hash_code) => {
        try {
            setLoadingGetPermissions(true);
            const response = await AuthenticationService.getPermissions({ role_hash_code });
            if (response.status === 200) {
                setPermissions(response.data);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingGetPermissions(false);
        }
    }

    //Crear un permiso
    const [loadingCreatePermission, setLoadingCreatePermission] = useState(false);
    const createPermissionByRole = async (data) => {
        try {
            setLoadingCreatePermission(true);
            const dataCreate = {
                role_hash_code: roleUser.hash_code,
                section_hash_code: data.section_hash_code,
                name: data.name,
                actions: data.actions
            }
            const response = await AuthenticationService.createPermission(dataCreate);

            //resetear el estado del permiso
            setPermission({
                name: '',
                section_hash_code: '',
                actions: []
            })
            resetOpenSilder();

            setAlertSnackbar({
                open: true,
                message: "Permiso creado correctamente",
                severity: 'success'
            })

            await getPermissionsByRole(roleUser.hash_code);

        } catch (error) {
            console.log(error);
            setAlertSnackbar({
                open: true,
                message: error.response.data || "Ocurrió un error al crear el permiso",
                severity: 'error'
            })
        }
        finally {
            setLoadingCreatePermission(false);
        }
    }

    //Actualizar un permiso
    const [loadingUpdatePermission, setLoadingUpdatePermission] = useState(false);
    const updatePermissionByRole = async (data) => {
        try {
            setLoadingUpdatePermission(true);
            const dataUpdate = {
                hash_code: permission.hash_code,
                name: data.name,
                actions: data.actions,
                section_hash_code: data.section_hash_code,
                id: data.id
            }
            const response = await AuthenticationService.updatePermission(dataUpdate);
            await getPermissionsByRole(roleUser.hash_code);
            setAlertSnackbar({
                open: true,
                message: "Permiso actualizado correctamente",
                severity: 'success'
            })
            //resetear el estado del permiso
            setPermission({
                name: '',
                section_hash_code: '',
                actions: []
            })
            resetOpenSilder();
        } catch (error) {
            console.log(error);
            setAlertSnackbar({
                open: true,
                message: error.response.data || "Ocurrió un error al actualizar el permiso",
                severity: 'error'
            })
        } finally {
            setLoadingUpdatePermission(false);
        }
    }

    //Eliminar un permiso
    const [loadingDeletePermission, setLoadingDeletePermission] = useState(false);
    const deletePermissionByRole = async (id) => {


        try {
            const confirmate = await Swal.fire({
                title: '¿Estás seguro?',
                text: 'Esta acción no se puede deshacer',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                customClass: {
                    container: 'custom-swal2-container',
                    popup: 'custom-swal2-popup',
                    backdrop: 'custom-swal2-backdrop',
                }
            })
            if (!confirmate.isConfirmed) return
            setLoadingDeletePermission(true);
            const response = await AuthenticationService.deletePermission(id);

            await getPermissionsByRole(roleUser.hash_code);

            setAlertSnackbar({
                open: true,
                message: "Permiso eliminado correctamente",
                severity: 'success'
            })
        } catch (error) {
            console.log(error);
            setAlertSnackbar({
                open: true,
                message: error.response.data || "Ocurrió un error al eliminar el permiso",
                severity: 'error'
            })
        } finally {
            setLoadingDeletePermission(false);
        }
    }



    //Secciones
    const [loadingGetSections, setLoadingGetSections] = useState(false);
    const [sections, setSections] = useState([]);
    const getAllSections = async (params) => {
        try {
            setLoadingGetSections(true);
            const response = await AuthenticationService.getSections(params);
            if (response.status === 200) {
                setSections(response.data);
            }
        } catch (error) {
            console.log(error);
        }
        finally {
            setLoadingGetSections(false);
        }
    }




    return <AuthContext.Provider value={{
        isAuthenticated, setIsAuthenticated,
        authUser, setAuthUser,
        accessToken, setAccessToken,
        refreshToken, setRefreshToken,
        isInitialized,
        loginWithMicrosoft,
        loginWithEmail,
        logout,
        loadingLogout,
        loadingRedirectCallback,
        loadingLoginEmail,
        messageError,
        getLocalStorage,
        resetLocalStorage,
        loading,
        handleRedirectCallback,
        roleUser, setRoleUser,
        permission, setPermission,
        loadingGetRole,
        getRoleByHashCode,
        createRole,
        loadingCreateRole,
        updateRoleExist,
        loadingUpdateRole,
        permissions, setPermissions,
        loadingGetPermissions,
        getPermissionsByRole,
        createPermissionByRole,
        loadingCreatePermission,
        sections, setSections,
        loadingGetSections,
        getAllSections,
        updatePermissionByRole,
        loadingUpdatePermission,
        roles, setRoles,
        loadingGetRoles,
        getAllRoles,
        deletePermissionByRole,
        loadingDeletePermission,
        deleteRole,
        loadingDeleteRole,
    }}>{children}</AuthContext.Provider>
}